import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { VersionsService } from '@app/services/app/versions.service';
import { ProjectsService } from '@app/services/app/projects.service';
import { LibraryService } from '@app/services/app/library.service';
import { AppService } from 'app/services/app/app.service';


import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

@Component({
    selector: 'dashboard-views-table-details-artworks',
    templateUrl: './artworks.component.html',
    styleUrls: ['./artworks.component.scss']
})
export class DashboardViewsTableDetailsArtworksComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    public readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';
    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";

    @Input() project: Objects.ExtendedRequest;

    public status:number = this.LOADING;
    public feedbackPluginAccess: boolean = false;
    public versions: Array<Objects.Version> = null;
    public feedbacks: Array<VersionShareItem> = null;


    protected subscriptor: Subscription;
    protected appSubscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription;


    constructor(private versionSharesSrv: VersionSharesService, public app: AppService,
        private versionsSrv: VersionsService, 
        private librarySrv: LibraryService,
        private projectsSrv: ProjectsService
        ) { }

    ngOnInit() {
        // HERE LOAD version status Access on Library Store to let us update version status. 
        // this.librarySrv.loadVersionsStatusAccess();
        // get plugins access
        this.appSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.feedbackPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_REQUEST_FEEDBACK);
        });
        this.subscriptor =  this.projectsSrv.selectUploadedVersions().subscribe((versions: Objects.Version[]) => {
            this.feedbacksSubscriptor?.unsubscribe();
            if(versions != null){
                this.versions = versions;
                this.initFeedbacks(versions);
            } else {
                // a new project is loading: never keep showing the previous project's versions
                this.versions = null;
                this.feedbacks = null;
                this.status = this.LOADING;
            }
            this.init();
        });

    }

    ngOnDestroy() {
        this.subscriptor.unsubscribe();
        this.appSubscriptor.unsubscribe();
        this.feedbacksSubscriptor?.unsubscribe();
    }

    init(){
        if(this.project == null || this.versions == null)
            return;
        this.status = this.DONE;
    }

    // feedbacks come  by list of versions, here we check access and no versions access (empty versions list)
    protected initFeedbacks(versions: Array<Objects.Version>) {
        if(!this.feedbackPluginAccess || versions.length == 0) {
            this.feedbacks = [];
            return;
        }
        // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by VersionSharesService.getVersionShareItems$
        // this.versionsSrv.getFeedbacks$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
        // a late response for a previous versions list would overwrite the current feedbacks
        this.feedbacksSubscriptor = this.versionSharesSrv.getVersionShareItems$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
               this.feedbacks = feedbacks;
        });
    }

}